import request from './request';

export async function getGroups(params) {
  return await request('get', `/apiv2/groups`, params);
}

export function createGroup(data) {
  return request('post', `/apiv2/groups`, data);
}

export function updateGroup(id, group) {
  return request('post', `/apiv2/groups/${id}/update`, group);
}

export function updateGroupImage(id, group) {
  return request('put', `/apiv2/groups/${id}/update-image`, group);
}

export function updateGroupPrivacy(id, group) {
  return request('put', `/apiv2/groups/${id}/update-privacy`, group);
}

export function deleteGroup(id) {
  return request('post', `/apiv2/groups/${id}/delete`);
}

export async function join(id) {
  return await request('post', `/apiv2/groups/${id}/join`);
}

export async function leave(id) {
  return await request('post', `/apiv2/groups/${id}/leave`);
}

export async function getNews(id) {
  return await request('get', `/apiv2/groups/${id}/news`);
}

export async function getUpcomingEvents(id) {
  return await request('get', `/apiv2/groups/${id}/upcoming-events`);
}

export async function getMembers(id) {
  return await request('get', `/apiv2/groups/${id}/members`);
}

export async function getCountPendingMembers(id) {
  return await request('get', `/apiv2/groups/${id}/count-pending-members`);
}

export async function acceptMember(group, id) {
  return await request('post', `/apiv2/groups/${group}/members/${id}/accept`);
}

export async function rejectMember(group, id) {
  return await request('post', `/apiv2/groups/${group}/members/${id}/reject`);
}

export async function unblockMember(group, id) {
  return await request('post', `/apiv2/groups/${group}/members/${id}/unblock`);
}

export async function removeMember(group, id) {
  return await request('post', `/apiv2/groups/${group}/members/${id}/remove`);
}

export async function blockMember(group, id) {
  return await request('post', `/apiv2/groups/${group}/members/${id}/block`);
}

export async function getPendingJoinedMembers(id, type, params) {
  return await request('get', `/apiv2/groups/${id}/${type}-members`, params);
}

export async function getMembersToInvite({ id, params }) {
  return await request('get', `/apiv2/groups/${id}/members-to-invite`, params);
}

export function inviteMembers({ id, data }) {
  return request('post', `/apiv2/groups/${id}/invite-members`, data);
}

export async function getOfficialGroups() {
  return await request('get', `/apiv2/groups/official-groups`);
}

export function joinOfficialGroups(params) {
  return request('post', `/apiv2/groups/join-official-groups`, params);
}

export function hideGroupOnboarding({ id }) {
  return request('post', `/apiv2/groups/${id}/hide-onboarding`, {});
}

export async function deactivate(id) {
  return await request('post', `/apiv2/groups/${id}/deactivate`);
}

export async function reactivate(id) {
  return await request('post', `/apiv2/groups/${id}/reactivate`);
}

export async function addRules(id, data) {
  return await request('post', `/apiv2/groups/${id}/rules`, data);
}

export async function getMyGroups(params) {
  return await request('get', `/apiv2/groups/created`, params);
}
